import { render, staticRenderFns } from "./PUpload.vue?vue&type=template&id=9b392c38&"
import script from "./PUpload.vue?vue&type=script&lang=js&"
export * from "./PUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports